import React from 'react'
export const Email = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.877"
      height="16.387"
      viewBox="0 0 17.877 16.387"
    >
      <path
        id="envelope_1_"
        data-name="envelope (1)"
        d="M14.152,1H3.724A3.729,3.729,0,0,0,0,4.724v8.938a3.729,3.729,0,0,0,3.724,3.724H14.152a3.729,3.729,0,0,0,3.724-3.724V4.724A3.729,3.729,0,0,0,14.152,1ZM3.724,2.49H14.152A2.235,2.235,0,0,1,16.223,3.9l-5.7,5.7a2.24,2.24,0,0,1-3.161,0l-5.7-5.7A2.235,2.235,0,0,1,3.724,2.49ZM14.152,15.9H3.724A2.235,2.235,0,0,1,1.49,13.663V5.842L6.3,10.653a3.73,3.73,0,0,0,5.268,0l4.815-4.812v7.821A2.235,2.235,0,0,1,14.152,15.9Z"
        transform="translate(0 -1)"
        fill="#99acd2"
      />
    </svg>
  )
}
export const Nftminting = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17.937"
      viewBox="0 0 18 17.937"
    >
      <path
        id="Union_17"
        data-name="Union 17"
        d="M9.405,17.876c-.406-.124-.45-.327-.45-.727v-.116l-.39-.208a7.7,7.7,0,0,1-1.395-.881.506.506,0,0,1-.2-.425.794.794,0,0,1,.147-.442c.024-.041.044-.078.059-.107-.009-.031-.021-.071-.036-.117a3.933,3.933,0,0,1-.259-1.611.939.939,0,0,1,.567-.552,8.345,8.345,0,0,1,1.085-.4l.035-.01c.075-.021.147-.041.187-.055A.346.346,0,0,1,8.77,12.2l.007-.018a.653.653,0,0,1,.645-.486,2.307,2.307,0,0,1,.553.091,5.366,5.366,0,0,1,.721.227,11.869,11.869,0,0,1,.184-1.761c.13-.6.279-.848.864-.848h.062l.076-.116a7.327,7.327,0,0,1,1.484-1.754.566.566,0,0,1,.256-.071,1.056,1.056,0,0,1,.367.1l.083.031a5.845,5.845,0,0,1,1.4-.695,1.218,1.218,0,0,1,.331-.044.873.873,0,0,1,.372.072,2.43,2.43,0,0,1,.881,1.338c.008.024.015.042.021.057l.018,0a.842.842,0,0,1,.292.1c.313.193.344.55.341,1.378,0,.355-.015.8-.03.993l0,.026c-.013.169-.029.378-.032.454l.013.009a.627.627,0,0,1,.321.649,4.331,4.331,0,0,1-.517,1.279l-.012.021c-.192.343-.212.379-.4.684-.057.092-.088.15-.107.185a1.963,1.963,0,0,1,.072.381v.009c0,.393-.6.737-.966.907a8.919,8.919,0,0,1-2.12.617l.186.118c.617.4.783.5.783.837a.474.474,0,0,1-.163.386.479.479,0,0,1-.391.163.735.735,0,0,1-.461-.181c-.212-.148-.492-.323-.645-.413-.113.084-.3.231-.388.305a2.3,2.3,0,0,1-1.133.571,5.233,5.233,0,0,1-1.447.141A2.731,2.731,0,0,1,9.405,17.876Zm.183-4.767c-.04.038-.1.091-.6.245a6.959,6.959,0,0,0-.975.335,8.766,8.766,0,0,0,.3,1.06.682.682,0,0,1-.032.613c.244.155.729.433,1.2.672a1.9,1.9,0,0,1,.5.3.591.591,0,0,1,.131.475l.111,0a6.2,6.2,0,0,0,1.181-.1,1.219,1.219,0,0,0,.655-.293c.044-.037.094-.078.143-.118-.415-.229-.91-.489-1.44-.751-.514-.253-.75-.368-.713-.753a.515.515,0,0,1,.5-.5.484.484,0,0,1,.061,0c.164,0,.283.06.86.35.56.281.916.465,1.247.646-.017-.264-.043-.575-.063-.7a2.175,2.175,0,0,0-.611-1.224l-.02-.018a.712.712,0,0,1-.434.2,1.8,1.8,0,0,1-.5-.158c-.4-.175-.867-.354-1.178-.456l-.174-.052A.772.772,0,0,1,9.588,13.109Zm5.718-2.44a.927.927,0,0,1-.154.427,13.706,13.706,0,0,0-1.24,3.2c-.019.087-.058.253-.076.324a1.7,1.7,0,0,0-.009.252L14,14.84a6.472,6.472,0,0,0,1.836-.595.636.636,0,0,1-.015-.412,3.82,3.82,0,0,1,.247-.438c.1-.16.156-.256.174-.288a2.9,2.9,0,0,1,.147-.264c.1-.17.3-.559.4-.773-.256-.176-.292-.322-.272-.656.005-.066.013-.179.022-.315.009-.152.021-.331.032-.5.029-.453.039-.969.035-1.223a.921.921,0,0,1-.357-.175l-.012-.013a.9.9,0,0,1-.157-.284,5.047,5.047,0,0,0-.39-.9,7.348,7.348,0,0,0-1.127.619.719.719,0,0,1-.408.144.938.938,0,0,1-.354-.082l-.054-.021a16.289,16.289,0,0,0-1.021,1.4c-.239.365-.32.438-.708.458l-.031,0c-.023.139-.054.367-.087.67-.028.258-.043.625-.048.9a1.664,1.664,0,0,1,1.29.785c.148-.439.3-.837.4-1.083l.137-.306c.1-.233.46-.93.552-1.078l0,0a.7.7,0,0,1,.257-.253.594.594,0,0,1,.245-.053A.567.567,0,0,1,15.306,10.669ZM5.153,13.112a7.071,7.071,0,0,1-.931-.28l-.007,0c-.033-.015-.084-.034-.105-.042a9.715,9.715,0,0,1-.95-.481A6.727,6.727,0,0,1,.194,8.251a6.823,6.823,0,0,1,0-3.218A6.664,6.664,0,0,1,6.029.02C6.193.007,6.393,0,6.606,0a6.69,6.69,0,0,1,1.08.073A6.475,6.475,0,0,1,10.6,1.309a4.915,4.915,0,0,1,.763.665,6.565,6.565,0,0,1,1.789,3.362c.1.507.188.944-.2,1.148a.575.575,0,0,1-.84-.5A7.538,7.538,0,0,0,11.8,4.675a.37.37,0,0,1-.069-.164,7.161,7.161,0,0,0-.364-.715,6.883,6.883,0,0,0-.654-.882A6.073,6.073,0,0,0,9.4,1.862c-.186-.108-.468-.248-.543-.28a.972.972,0,0,1-.167-.066,6.048,6.048,0,0,0-1.206-.337,7.613,7.613,0,0,0-.937-.042,5.415,5.415,0,0,0-.7.029c-.071.016-.207.044-.4.084a5.827,5.827,0,0,0-1.177.4A5.632,5.632,0,0,0,1.863,3.875a6.268,6.268,0,0,0-.32.636.36.36,0,0,1-.063.155,5.373,5.373,0,0,0-.176.561,5.826,5.826,0,0,0-.151.8,10.286,10.286,0,0,0,.022,1.4,7.03,7.03,0,0,0,.171.751,5.511,5.511,0,0,0,3.711,3.731c.138.041.237.068.269.076a.757.757,0,0,1,.2.053l.005,0a.566.566,0,0,1,.341.423.529.529,0,0,1-.144.484.574.574,0,0,1-.413.179A.786.786,0,0,1,5.153,13.112Zm1.016-2.591c-.056-.035-.1-.058-.117-.069a2.537,2.537,0,0,1-.274-.157c-.1-.06-.172-.1-.2-.116a1.6,1.6,0,0,1-.2-.112h0c-.078-.047-.2-.118-.258-.151L5.11,9.91l-.167-.1-.354-.2-.236-.135-.271-.155-.148-.085-.111-.065-.005,0c-.085-.051-.178-.105-.214-.123l0,0a1.258,1.258,0,0,1-.512-.427c-.07-.145-.071-.163-.066-2.009.009-1.867.013-1.877.073-1.994a.785.785,0,0,1,.338-.3l.524-.3c.176-.1.374-.215.441-.253.048-.027.14-.082.213-.126l.042-.025a1.541,1.541,0,0,1,.2-.11c.027-.015.1-.056.2-.117a2.515,2.515,0,0,1,.275-.156c.019-.011.06-.034.115-.068l.043-.026c.084-.05.188-.112.253-.149l.1-.056.315-.177c.34-.2.437-.2.489-.2s.148,0,.49.2l.313.177.1.056c.072.04.176.1.229.135s.12.072.183.107.263.149.442.253l.182.105.371.216c.132.076.353.2.462.268l.081.046.349.2a.8.8,0,0,1,.341.3c.059.119.064.129.073,2,.005,1.846,0,1.864-.064,2.006l0,.008a1.27,1.27,0,0,1-.531.434c-.058.032-.216.122-.347.2l-.273.158-.274.158c-.167.094-.443.255-.626.361l-.007,0c-.179.1-.376.216-.441.253-.049.027-.141.083-.216.128l-.04.024a1.319,1.319,0,0,1-.205.113c-.019.011-.06.034-.118.07a.883.883,0,0,1-.467.175A.9.9,0,0,1,6.169,10.521ZM8.617,6.209l-.3.173-.428.247L7.6,6.8l-.112.066-.263.152L7.219,8.232c0,.379,0,.687,0,.913.043-.026.088-.052.122-.071.06-.034.257-.146.434-.248s.535-.31.8-.464L8.854,8.2l.244-.14V6.847c0-.366,0-.682,0-.914Zm-4.438.642.006,1.217.107.062.677.39.149.086c.329.19.635.364.69.4s.148.086.23.136l.014.008c0-.226,0-.534,0-.913L6.046,7.008l-.059-.032-.524-.3c-.176-.1-.373-.214-.434-.248s-.151-.089-.235-.14L4.76,6.265c-.058-.036-.1-.059-.119-.07a2.707,2.707,0,0,1-.275-.156c-.088-.053-.153-.091-.186-.11C4.178,6.13,4.178,6.424,4.179,6.851Zm2.313-3c-.175.105-.257.155-.311.178s-.147.086-.194.115c-.142.085-.214.128-.263.15-.026.014-.1.055-.2.117a2.608,2.608,0,0,1-.275.156c-.02.011-.06.034-.115.068l-.005,0c-.088.052-.208.124-.282.164l-.177.1.114.066.031.018.837.487L5.9,5.62c.131.075.353.2.463.268l.148.085.123.071.13-.076.5-.3c.151-.09.228-.135.279-.157.027-.014.106-.059.218-.124.139-.084.352-.208.472-.277L8.607,4.9,8.316,4.73l-.433-.247c-.049-.023-.121-.067-.255-.147s-.183-.106-.2-.117c-.049-.023-.121-.066-.263-.15-.1-.062-.174-.1-.2-.118a2.59,2.59,0,0,1-.244-.139l-.084-.049C6.6,3.786,6.547,3.815,6.492,3.848Z"
        fill={props.color}
      />
    </svg>
  )
}
export const ProjectMangement = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        id="users-alt_1_"
        data-name="users-alt (1)"
        d="M4.233,7.333H2A.667.667,0,0,0,1.333,8v2H0V8A2,2,0,0,1,2,6H5.025a3.985,3.985,0,0,0-.792,1.333ZM14,6H10.975a3.985,3.985,0,0,1,.792,1.333H14A.667.667,0,0,1,14.667,8v2H16V8A2,2,0,0,0,14,6ZM10.667,8.667A2.667,2.667,0,1,0,8,11.333,2.667,2.667,0,0,0,10.667,8.667Zm-1.333,0A1.333,1.333,0,1,1,8,7.333,1.333,1.333,0,0,1,9.333,8.667ZM12,14a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v2H5.333V14A.667.667,0,0,1,6,13.333h4a.667.667,0,0,1,.667.667v2H12ZM14.667,2.667A2.667,2.667,0,1,0,12,5.333a2.667,2.667,0,0,0,2.667-2.667Zm-1.333,0A1.333,1.333,0,1,1,12,1.333,1.333,1.333,0,0,1,13.333,2.667Zm-6.667,0A2.667,2.667,0,1,0,4,5.333,2.667,2.667,0,0,0,6.667,2.667Zm-1.333,0A1.333,1.333,0,1,1,4,1.333,1.333,1.333,0,0,1,5.333,2.667Z"
        fill={props.color}
      />
    </svg>
  )
}
export const Payments = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.051"
      height="15"
      viewBox="0 0 18.051 15"
    >
      <g id="Group_63283" data-name="Group 63283" transform="translate(0)">
        <path
          id="Path_88207"
          data-name="Path 88207"
          d="M1163.665,23.3h-10.678a3.691,3.691,0,0,1-3.687-3.687V11.986a3.691,3.691,0,0,1,3.687-3.687h10.678a3.691,3.691,0,0,1,3.687,3.687v7.627A3.691,3.691,0,0,1,1163.665,23.3ZM1152.987,9.571a2.418,2.418,0,0,0-2.415,2.415v7.627a2.418,2.418,0,0,0,2.415,2.415h10.678a2.418,2.418,0,0,0,2.415-2.415V11.986a2.418,2.418,0,0,0-2.415-2.415Zm10.678,9.916h-10.678a.636.636,0,0,1,0-1.271h10.678a.636.636,0,0,1,0,1.271Zm-.763-3.051h-3.051a1.4,1.4,0,0,1-1.4-1.4V13.512a1.4,1.4,0,0,1,1.4-1.4h3.051a1.4,1.4,0,0,1,1.4,1.4v1.526A1.4,1.4,0,0,1,1162.9,16.435Zm-3.179-3.05v1.779h3.306V13.385Zm-3.687,3.05h-3.05a.636.636,0,0,1,0-1.271h3.05a.636.636,0,1,1,0,1.271Z"
          transform="translate(-1149.3 -8.3)"
          fill={props.color}
        />
      </g>
    </svg>
  )
}
export const Cowbell = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="15.574"
      height="16.985"
      viewBox="0 0 15.574 16.985"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          y1="0.199"
          x2="0.882"
          y2="0.733"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#4f81fd" />
          <stop offset="1" stopColor="#c03dfd" />
        </linearGradient>
      </defs>
      <path
        id="cowbell"
        d="M16.532,10.828l-.906-5.081A3.522,3.522,0,0,0,12.2,2.838a2.172,2.172,0,0,0,.134-.715A2.129,2.129,0,0,0,10.212,0H7.381A2.129,2.129,0,0,0,5.258,2.123a2.034,2.034,0,0,0,.134.715A3.529,3.529,0,0,0,1.967,5.747l-.906,5.081A2.828,2.828,0,0,0,3.85,14.154H5.973a2.831,2.831,0,1,0,5.662,0h2.123a2.828,2.828,0,0,0,2.788-3.326ZM7.374,1.415h2.831a.708.708,0,1,1,0,1.415H7.374a.708.708,0,0,1,0-1.415ZM8.79,15.57a1.42,1.42,0,0,1-1.415-1.415h2.831A1.42,1.42,0,0,1,8.79,15.57Zm6.037-3.34a1.4,1.4,0,0,1-1.083.51H3.836a1.4,1.4,0,0,1-1.083-.51,1.434,1.434,0,0,1-.311-1.161l.906-5.081A2.124,2.124,0,0,1,5.435,4.239h6.7a2.113,2.113,0,0,1,2.088,1.748l.906,5.081a1.414,1.414,0,0,1-.3,1.154Z"
        transform="translate(-1.017)"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}
export const Edit = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="13.434"
      height="13.435"
      viewBox="0 0 13.434 13.435"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#4f81fd" />
          <stop offset="1" stopColor="#c03dfd" />
        </linearGradient>
      </defs>
      <g
        id="Icon_feather-edit"
        data-name="Icon feather-edit"
        transform="translate(-2.3 -2.118)"
      >
        <path
          id="Union_15"
          data-name="Union 15"
          d="M1.879,13.435A1.881,1.881,0,0,1,0,11.555v-8.4a1.882,1.882,0,0,1,1.879-1.88h4.2a.678.678,0,0,1,0,1.357h-4.2a.524.524,0,0,0-.523.523v8.4a.524.524,0,0,0,.523.523h8.4a.524.524,0,0,0,.523-.523v-4.2a.678.678,0,1,1,1.356,0v4.2a1.881,1.881,0,0,1-1.879,1.879ZM3.8,9.635a.681.681,0,0,1-.179-.644l.6-2.4A.681.681,0,0,1,4.4,6.274l5.7-5.7a1.951,1.951,0,0,1,2.759,2.76l-5.7,5.7a.685.685,0,0,1-.315.178l-2.4.6a.69.69,0,0,1-.163.02A.68.68,0,0,1,3.8,9.635Zm7.262-8.1L5.492,7.1l-.28,1.122,1.122-.28L11.9,2.373a.6.6,0,1,0-.842-.842Z"
          transform="translate(2.3 2.118)"
          fill="url(#linear-gradient)"
        />
      </g>
    </svg>
  )
}
export const FileUploader = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="35.455"
      height="32.5"
      viewBox="0 0 35.455 32.5"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#4f81fd" />
          <stop offset="1" stopColor="#c03dfd" />
        </linearGradient>
      </defs>
      <path
        id="folder-upload"
        d="M35.455,11.734v13.3a8.135,8.135,0,0,1-8.125,8.125H25.853a2.216,2.216,0,0,1,0-4.432H27.33a3.7,3.7,0,0,0,3.693-3.693v-13.3A3.684,3.684,0,0,0,30.948,11H4.432V25.029a3.7,3.7,0,0,0,3.693,3.693H9.6a2.216,2.216,0,0,1,0,4.432H8.125A8.136,8.136,0,0,1,0,25.029V8.779A8.136,8.136,0,0,1,8.125.654H11.86a5.2,5.2,0,0,1,2.312.545l4.661,2.33a.728.728,0,0,0,.331.08H27.33a8.135,8.135,0,0,1,8.125,8.125ZM23.446,20.29l-4.673-4.673a1.476,1.476,0,0,0-2.089,0L12.012,20.29a1.477,1.477,0,0,0,1.044,2.522h2.457v8.127a2.216,2.216,0,0,0,4.432,0V22.812H22.4a1.477,1.477,0,0,0,1.044-2.522Z"
        transform="translate(0 -0.654)"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}
export const Settings = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="15.283"
      height="16.985"
      viewBox="0 0 15.283 16.985"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          y1="0.199"
          x2="0.882"
          y2="0.733"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#4f81fd" />
          <stop offset="1" stopColor="#c03dfd" />
        </linearGradient>
      </defs>
      <g
        id="settings_1_"
        data-name="settings (1)"
        transform="translate(-1.203)"
      >
        <path
          id="Path_88193"
          data-name="Path 88193"
          d="M10.831,8a2.831,2.831,0,1,0,2.831,2.831A2.831,2.831,0,0,0,10.831,8Zm0,4.246a1.415,1.415,0,1,1,1.415-1.415A1.415,1.415,0,0,1,10.831,12.246Z"
          transform="translate(-1.987 -2.338)"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_88194"
          data-name="Path 88194"
          d="M15.422,9.837l-.314-.181a6.44,6.44,0,0,0,0-2.328l.314-.181A2.124,2.124,0,1,0,13.3,3.466l-.315.182a6.353,6.353,0,0,0-2.016-1.162V2.123a2.123,2.123,0,1,0-4.246,0v.363A6.353,6.353,0,0,0,4.705,3.651l-.316-.183a2.124,2.124,0,1,0-2.123,3.68l.314.181a6.44,6.44,0,0,0,0,2.328l-.314.181a2.124,2.124,0,1,0,2.123,3.68l.315-.182A6.353,6.353,0,0,0,6.721,14.5v.363a2.123,2.123,0,1,0,4.246,0V14.5a6.353,6.353,0,0,0,2.016-1.165l.316.183a2.124,2.124,0,0,0,2.123-3.68Zm-1.8-2.672a4.988,4.988,0,0,1,0,2.654.708.708,0,0,0,.328.8l.767.443a.708.708,0,1,1-.708,1.226l-.769-.444a.708.708,0,0,0-.86.117,4.943,4.943,0,0,1-2.3,1.327.708.708,0,0,0-.531.686v.887a.708.708,0,0,1-1.415,0v-.886A.708.708,0,0,0,7.6,13.29,4.943,4.943,0,0,1,5.31,11.96a.708.708,0,0,0-.86-.117l-.767.444a.708.708,0,1,1-.708-1.226l.767-.443a.708.708,0,0,0,.328-.8,4.988,4.988,0,0,1,0-2.654.708.708,0,0,0-.329-.8l-.767-.443a.708.708,0,1,1,.708-1.226l.769.444a.708.708,0,0,0,.859-.114A4.943,4.943,0,0,1,7.6,3.7a.708.708,0,0,0,.531-.689V2.123a.708.708,0,0,1,1.415,0v.886a.708.708,0,0,0,.531.686,4.943,4.943,0,0,1,2.3,1.33.708.708,0,0,0,.86.117l.767-.444a.708.708,0,1,1,.708,1.226l-.767.443a.708.708,0,0,0-.328.8Z"
          fill="url(#linear-gradient)"
        />
      </g>
    </svg>
  )
}
export const Star = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="13"
      height="12"
      viewBox="0 0 13 12"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#4f81fd" />
          <stop offset="1" stopColor="#e30d7f" />
        </linearGradient>
      </defs>
      <path
        id="Polygon_2"
        data-name="Polygon 2"
        d="M6.013,2.129a.5.5,0,0,1,.975,0l.234,1.024A.5.5,0,0,0,8,3.445l.874-.637a.5.5,0,0,1,.73.65l-.447.791a.5.5,0,0,0,.418.746l.945.033a.5.5,0,0,1,.161.967l-.828.315a.5.5,0,0,0-.145.849l.665.564a.5.5,0,0,1-.468.86l-.98-.3a.5.5,0,0,0-.639.552l.143.967a.5.5,0,0,1-.91.351l-.607-.907a.5.5,0,0,0-.831,0l-.607.907a.5.5,0,0,1-.91-.351l.143-.967a.5.5,0,0,0-.639-.552l-.98.3a.5.5,0,0,1-.468-.86l.665-.564a.5.5,0,0,0-.145-.849l-.828-.315a.5.5,0,0,1,.161-.967l.945-.033a.5.5,0,0,0,.418-.746l-.447-.791a.5.5,0,0,1,.73-.65L5,3.445a.5.5,0,0,0,.782-.292Z"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}
export const Tick = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="59.849"
      height="59.874"
      viewBox="0 0 59.849 59.874"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.127"
          y1="0.335"
          x2="1.278"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <g
        id="_Pngtree_check-mark-vector-icon_5552269"
        data-name="—Pngtree—check-mark-vector-icon_5552269"
        transform="translate(-300.5 2699.926)"
      >
        <path
          id="Path_87466"
          data-name="Path 87466"
          d="M329.028-2699.9a30.074,30.074,0,0,0-18.673,7.684c-.467.419-1.577,1.522-1.986,1.968a30.049,30.049,0,0,0-7.754,17.476,23.127,23.127,0,0,0-.115,2.744,23.8,23.8,0,0,0,.115,2.769,30.014,30.014,0,0,0,6.626,16.221,30.085,30.085,0,0,0,15.987,10.114,30.012,30.012,0,0,0,11.351.581,29.985,29.985,0,0,0,15.892-7.395c.514-.459,1.724-1.669,2.183-2.183a30.331,30.331,0,0,0,5.5-8.777,30.043,30.043,0,0,0,2.081-8.537,23.672,23.672,0,0,0,.115-2.757,23.667,23.667,0,0,0-.115-2.756,29.862,29.862,0,0,0-1.058-5.588c-.2-.688-.252-.813-.394-.9a.506.506,0,0,0-.407-.065,3.767,3.767,0,0,0-1.275,1.1,3.158,3.158,0,0,0-.434,2.582,26.817,26.817,0,0,1,.432,5.656c-.037,1-.077,1.517-.182,2.377a26.434,26.434,0,0,1-4.154,11.344,25.965,25.965,0,0,1-13.606,10.418,25.806,25.806,0,0,1-6.5,1.23c-.574.037-2.258.037-2.856,0a26.1,26.1,0,0,1-3.6-.467,25,25,0,0,1-13.786-7.931,24.506,24.506,0,0,1-6.07-14,20.759,20.759,0,0,1-.095-2.2,22.477,22.477,0,0,1,.329-4.021,23.789,23.789,0,0,1,5.658-11.858c.457-.519,1.539-1.6,2.063-2.058a23.261,23.261,0,0,1,13.035-5.7,23.489,23.489,0,0,1,4.491-.012,22.7,22.7,0,0,1,6.781,1.734,5.189,5.189,0,0,0,1.894.494,5.024,5.024,0,0,0,3.338-.99,8.154,8.154,0,0,0,1.786-1.924,1.7,1.7,0,0,0,.439-1.225,1.3,1.3,0,0,0-.247-.763c-.2-.3-.382-.424-1.512-1.021a29.994,29.994,0,0,0-11.656-3.33A35.66,35.66,0,0,0,329.028-2699.9Z"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_87467"
          data-name="Path 87467"
          d="M940.732-2381.506a1.632,1.632,0,0,0-.387.135c-.182.092-1.345,1.1-13.447,11.68-8.627,7.542-13.287,11.6-13.359,11.633a.7.7,0,0,1-.314.052.549.549,0,0,1-.339-.075c-.11-.058-1.165-1.073-4.815-4.615-2.57-2.5-4.852-4.713-5.072-4.927-.549-.531-.8-.659-1.285-.659a1.461,1.461,0,0,0-1.32.811,1.467,1.467,0,0,0,.142,1.589c.257.4,9.47,14.577,9.642,14.836a4.138,4.138,0,0,0,.861.886,3.744,3.744,0,0,0,1.355.589,4.664,4.664,0,0,0,1.345,0,3.538,3.538,0,0,0,1.669-.851c.13-.122,24.294-26.03,26.647-28.57a1.739,1.739,0,0,0,.389-.668,1.686,1.686,0,0,0,0-.773A1.5,1.5,0,0,0,940.732-2381.506Z"
          transform="translate(-584.761 -310.45)"
          fill="url(#linear-gradient)"
        />
      </g>
    </svg>
  )
}
